<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    max-width="400px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="value"
        :label="label"
        readonly
        v-bind="attrs"
        v-on="on"
        prepend-inner-icon="mdi-palette"
        :hint="hint"
        persistent-hint
      >
        <template v-slot:append>
          <div
            class="gradient-preview"
            :style="{ 
              background: value || defaultGradient,
              width: '60px', 
              height: '32px', 
              border: '2px solid #ccc',
              borderRadius: '4px',
              cursor: 'pointer'
            }"
          ></div>
        </template>
      </v-text-field>
    </template>
    <v-card>
      <v-card-title class="py-2">
        <span class="text-subtitle-1">Selecionar Gradient</span>
        <v-spacer></v-spacer>
        <v-btn icon small @click="menu = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-2">
        <!-- Preview do Gradient -->
        <div class="gradient-preview-large mb-3" :style="{ background: generateGradient() }">
          <span class="preview-text">Preview</span>
        </div>

        <!-- Layout compacto com cores lado a lado -->
        <v-row class="color-pickers-row">
          <v-col cols="6" class="pr-2">
            <div class="color-section">
              <div class="color-header">
                <span class="color-label">Cor 1 (0%)</span>
                <v-text-field
                  v-model="gradientColor1"
                  dense
                  outlined
                  hide-details
                  class="color-input"
                  :style="{ backgroundColor: gradientColor1 + '15' }"
                />
              </div>
              <v-color-picker
                v-model="gradientColor1"
                hide-mode-switch
                mode="hexa"
                show-swatches
                :swatches="compactSwatches"
                width="100%"
                class="compact-picker"
              ></v-color-picker>
            </div>
          </v-col>
          <v-col cols="6" class="pl-2">
            <div class="color-section">
              <div class="color-header">
                <span class="color-label">Cor 2 (100%)</span>
                <v-text-field
                  v-model="gradientColor2"
                  dense
                  outlined
                  hide-details
                  class="color-input"
                  :style="{ backgroundColor: gradientColor2 + '15' }"
                />
              </div>
              <v-color-picker
                v-model="gradientColor2"
                hide-mode-switch
                mode="hexa"
                show-swatches
                :swatches="compactSwatches"
                width="100%"
                class="compact-picker"
              ></v-color-picker>
            </div>
          </v-col>
        </v-row>

        <!-- Gradients predefinidos mais compactos -->
        <div class="preset-section mt-3">
          <span class="preset-label">Gradients Populares</span>
          <div class="preset-grid">
            <div
              v-for="(gradient, index) in predefinedGradients" 
              :key="index"
              class="gradient-option"
              :style="{ background: gradient.css }"
              @click="selectPredefinedGradient(gradient)"
            ></div>
          </div>
        </div>

      </v-card-text>
      <v-card-actions class="py-2">
        <v-btn text small @click="resetGradient">
          Resetar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text small @click="menu = false">
          Cancelar
        </v-btn>
        <v-btn color="primary" small @click="confirmGradient">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'GradientColorPicker',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Gradient'
    },
    hint: {
      type: String,
      default: 'Clique para selecionar as cores do gradient'
    },
    defaultGradient: {
      type: String,
      default: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
    }
  },
  data() {
    return {
      menu: false,
      gradientColor1: '#f093fb',
      gradientColor2: '#f5576c',
      compactSwatches: [
        ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4'],
        ['#f093fb', '#f5576c', '#4facfe', '#00f2fe']
      ],
      predefinedGradients: [
        { css: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', color1: '#f093fb', color2: '#f5576c' },
        { css: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', color1: '#4facfe', color2: '#00f2fe' },
        { css: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', color1: '#43e97b', color2: '#38f9d7' },
        { css: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', color1: '#fa709a', color2: '#fee140' },
        { css: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', color1: '#a8edea', color2: '#fed6e3' },
        { css: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)', color1: '#ffecd2', color2: '#fcb69f' },
        { css: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color1: '#667eea', color2: '#764ba2' },
        { css: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)', color1: '#f6d365', color2: '#fda085' },
        { css: 'linear-gradient(135deg, #96fbc4 0%, #f9f586 100%)', color1: '#96fbc4', color2: '#f9f586' }
      ]
    }
  },
  methods: {
    generateGradient() {
      return `linear-gradient(135deg, ${this.gradientColor1} 0%, ${this.gradientColor2} 100%)`;
    },
    
    confirmGradient() {
      this.$emit('input', this.generateGradient());
      this.menu = false;
    },
    
    resetGradient() {
      this.gradientColor1 = '#f093fb';
      this.gradientColor2 = '#f5576c';
    },
    
    selectPredefinedGradient(gradient) {
      this.gradientColor1 = gradient.color1;
      this.gradientColor2 = gradient.color2;
    },
    
    extractColorsFromGradient() {
      if (this.value && this.value.includes('linear-gradient')) {
        const matches = this.value.match(/#[a-fA-F0-9]{6}/g);
        if (matches && matches.length >= 2) {
          this.gradientColor1 = matches[0];
          this.gradientColor2 = matches[1];
        }
      }
    }
  },
  
  watch: {
    menu(newVal) {
      if (newVal) {
        this.extractColorsFromGradient();
      }
    }
  }
}
</script>

<style scoped>
.gradient-preview-large {
  width: 100%;
  height: 60px;
  border-radius: 8px;
  border: 2px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.color-pickers-row {
  margin: 0 !important;
}

.color-section {
  height: 100%;
}

.color-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.color-label {
  font-size: 12px;
  font-weight: 500;
  color: #666;
  white-space: nowrap;
}

.color-input {
  width: 80px;
  margin-left: 8px;
}

.color-input >>> .v-input__control {
  min-height: 28px !important;
}

.color-input >>> .v-text-field__details {
  display: none;
}

.compact-picker {
  transform: scale(0.9);
  transform-origin: top left;
  margin-left: -5%;
  margin-top: -10px;
}

.preset-section {
  border-top: 1px solid #e0e0e0;
  padding-top: 12px;
}

.preset-label {
  font-size: 12px;
  font-weight: 500;
  color: #666;
  display: block;
  margin-bottom: 8px;
}

.preset-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 6px;
}

.gradient-option {
  width: 100%;
  height: 32px;
  border-radius: 4px;
  border: 2px solid #ccc;
  cursor: pointer;
  transition: transform 0.2s, border-color 0.2s;
}

.gradient-option:hover {
  transform: scale(1.05);
  border-color: #1976D2;
}

.preview-text {
  color: white;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.7);
  font-size: 12px;
}

.gradient-preview {
  position: relative;
}
</style>